import React from 'react';
import PlacesSearch from '../home/PlacesSearch';

const NotAvailable = props => {
	const { isLoading } = props;
	const geolocation = props.geolocation;
	return (
		<>
			<div className="not-available add-to-cart-selector">
				<div className="blured-content"></div>

				{isLoading ? (
					<div className="text-content checking-availability">
						<div className="inner">
							<div className="icon-container"></div>
							<div className="content-container">
								<h5>
									<i className="fas fa-info-circle"></i> Checking availability...
								</h5>

								<p>Our products and service availability are dependent on where you are located.</p>
							</div>
						</div>
					</div>
				) : (
					<div className="text-content">
						<div className="inner">
							<div className="icon-container"></div>

							<div className="content-container">
								<h5>
									<i className="fas fa-exclamation-triangle"></i>{' '}
									{geolocation.formatted_address || geolocation.formattedAddress
										? 'Not available'
										: 'Location Required'}
								</h5>

								<p>Our products and service availability are dependent on where you are located.</p>

								{geolocation.formatted_address || geolocation.formattedAddress ? (
									<p className="mt-2">
										This product is not available for your current location{' '}
										<b>{geolocation.formatted_address || geolocation.formattedAddress}</b>
										<a className="btn book" href={`/category/${props.categoryUrlSlug}`}>
											See Available Products
										</a>
									</p>
								) : (
									<PlacesSearch isModalOpen={false} hasMyLocationButton />
								)}
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
};

export default NotAvailable;
